class StoreLocator extends HTMLElement {
  constructor() {
    super();
    this.toggleButtons = this.querySelectorAll('.store-locator__location-toggle');
    this.locations = this.querySelectorAll('.store-locator__location');
  }

  connectedCallback() {
    this.bindEvents();
    this.setupEventTracking();
  }

  bindEvents() {
    this.toggleButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleLocation(button);
      });
    });
  }

  setupEventTracking() {
    const storeLinks = this.querySelectorAll('.store-locator__store-link');
    storeLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        const storeName = link.querySelector('.store-locator__store-name')?.textContent.trim();
        const storeAddress = link.querySelector('.store-locator__store-address')?.textContent.trim();
        const area = link.closest('.store-locator__location')?.querySelector('.store-locator__location-toggle')?.textContent.trim();
        
        this.trackEvent('store_detail_click', {
          store_name: storeName,
          store_address: storeAddress,
          store_area: area,
          page_location: 'store_locator'
        });
      });
    });

    const directionsButtons = this.querySelectorAll('a[href*="google.com/maps"]');
    directionsButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const storeContainer = button.closest('.store-locator__store');
        const storeName = storeContainer?.querySelector('.store-locator__store-name')?.textContent.trim();
        const area = button.closest('.store-locator__location')?.querySelector('.store-locator__location-toggle')?.textContent.trim();
        
        this.trackEvent('get_directions_click', {
          store_name: storeName,
          store_area: area,
          action_type: 'directions'
        });
      });
    });

    const orderButtons = this.querySelectorAll('a[href*="order.graeters.com"]');
    orderButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const storeContainer = button.closest('.store-locator__store');
        const storeName = storeContainer?.querySelector('.store-locator__store-name')?.textContent.trim();
        const area = button.closest('.store-locator__location')?.querySelector('.store-locator__location-toggle')?.textContent.trim();
        const storeId = button.href.match(/store\/(\d+)/)?.[1];
        
        this.trackEvent('order_now_click', {
          store_name: storeName,
          store_area: area,
          store_id: storeId,
          action_type: 'order'
        });
      });
    });

    const foodTruckButtons = this.querySelectorAll('a[href*="food-truck#request-form"]');
    foodTruckButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const area = button.closest('.store-locator__location')?.querySelector('.store-locator__location-toggle')?.textContent.trim();
        
        this.trackEvent('food_truck_request_click', {
          store_area: area,
          action_type: 'food_truck_request'
        });
      });
    });

    const moreInfoButtons = this.querySelectorAll('a[href="/pages/catering"]');
    moreInfoButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const storeContainer = button.closest('.store-locator__store');
        const storeName = storeContainer?.querySelector('.store-locator__store-name')?.textContent.trim();
        const area = button.closest('.store-locator__location')?.querySelector('.store-locator__location-toggle')?.textContent.trim();
        
        this.trackEvent('food_truck_info_click', {
          store_name: storeName,
          store_area: area,
          action_type: 'food_truck_info'
        });
      });
    });
  }

  toggleLocation(button) {
    const location = button.closest('.store-locator__location');
    const content = location.querySelector('.store-locator__content');
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    const areaName = button.textContent.trim();

    this.locations.forEach(otherLocation => {
      const otherButton = otherLocation.querySelector('.store-locator__location-toggle');
      const otherContent = otherLocation.querySelector('.store-locator__content');

      otherLocation.classList.remove('is-active');
      otherButton.setAttribute('aria-expanded', 'false');
      otherContent.setAttribute('hidden', '');
    });

    if (!isExpanded) {
      location.classList.add('is-active');
      button.setAttribute('aria-expanded', 'true');
      content.removeAttribute('hidden');
      
      this.trackEvent('store_area_expand', {
        area_name: areaName,
        action: 'expand',
        total_stores: content.querySelectorAll('.store-locator__store').length
      });
    } else {
      this.trackEvent('store_area_collapse', {
        area_name: areaName,
        action: 'collapse'
      });
    }
  }

  trackEvent(eventName, parameters = {}) {
    if (typeof gtag !== 'undefined') {
      gtag('event', eventName, {
        ...parameters,
        page_type: 'store_locator',
        timestamp: new Date().toISOString()
      });
    }
    
    if (typeof dataLayer !== 'undefined') {
      dataLayer.push({
        event: eventName,
        ...parameters
      });
    }

    // console.log('GA4 Event:', eventName, parameters);
  }
}

if (!customElements.get('store-locator')) {
  customElements.define('store-locator', StoreLocator);
}